var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnPasswordLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0003 17H4.50004C2.56702 17 1 18.567 1 20.5V32.7502C1 34.6832 2.56702 36.2502 4.50004 36.2502H29.0003C30.9333 36.2502 32.5003 34.6832 32.5003 32.7502V20.5C32.5003 18.567 30.9333 17 29.0003 17Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05895 29.3182L9.14666 27.37L7.5032 28.4272L7 27.5501L8.74503 26.6591L7 25.7681L7.5032 24.891L9.14666 25.9482L9.05895 24H10.0607L9.97301 25.9482L11.6165 24.891L12.1197 25.7681L10.3746 26.6591L12.1197 27.5501L11.6165 28.4272L9.97301 27.37L10.0607 29.3182H9.05895Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8382 29.3182L15.926 27.37L14.2825 28.4272L13.7793 27.5501L15.5243 26.6591L13.7793 25.7681L14.2825 24.891L15.926 25.9482L15.8382 24H16.84L16.7523 25.9482L18.3958 24.891L18.899 25.7681L17.1539 26.6591L18.899 27.5501L18.3958 28.4272L16.7523 27.37L16.84 29.3182H15.8382Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6175 29.3182L22.7053 27.37L21.0618 28.4272L20.5586 27.5501L22.3036 26.6591L20.5586 25.7681L21.0618 24.891L22.7053 25.9482L22.6175 24H23.6193L23.5316 25.9482L25.1751 24.891L25.6783 25.7681L23.9332 26.6591L25.6783 27.5501L25.1751 28.4272L23.5316 27.37L23.6193 29.3182H22.6175Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00024 16.7502V9.75009C8.00024 7.42942 8.92213 5.2038 10.5631 3.56284C12.204 1.92188 14.4297 1 16.7503 1C19.071 1 21.2966 1.92188 22.9376 3.56284C24.5785 5.2038 25.5004 7.42942 25.5004 9.75009V16.7502",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPasswordLock);
export default __webpack_public_path__ + "static/media/icn-password-lock.d70a5d5cdd1acf09a11f628f214755ac.svg";
export { ForwardRef as ReactComponent };